import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2,
} from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';

@Directive({
  selector: '[appTag]',
})
export class TagDirective implements OnInit {
  @Input({ required: true })
  appTag!: string;

  constructor(
    private elementRef: ElementRef,
    private store: Store,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    // Construct the URL with the query parameter
    const href = `/gallery?search=${encodeURIComponent(this.appTag)}`;
    // Set the href attribute on the element
    this.renderer.setAttribute(this.elementRef.nativeElement, 'href', href);
  }

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.preventDefault(); // Prevent default navigation if necessary

    const extras: NavigationExtras = {
      queryParams: { search: this.appTag },
      queryParamsHandling: 'merge',
    };

    this.store.dispatch(new Navigate(['/gallery'], [], extras));
  }
}
